// extracted by mini-css-extract-plugin
module.exports = {"eyes":"_3lGwyuFPT4_YvZxmRYGd0P"};